import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/6995c42af782d500146e7f68/nightburnoj/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6995c42af782d500146e7f68/nightburnoj/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6995c42af782d500146e7f68/nightburnoj/src/components/ui/AppLogo.tsx");
